import get from 'lodash/get'

export const getCurrentUserFullName = state => state.appState.user.fullName

export const getIsAppLoading = state => state.appState.isLoading

export const getRvcUuid = state => get(state, 'appState.rvcUuid', null)
